import { createFrameworkSelectionStep, createRecipientSelectionStep, createMultiSelectEmployeeSelectionStep, createBodyLanguageFrameworkSelectionStep, createWrittenMessagesSelectionStep, createVerbalExpressionsSelectionStep, createAdditionalEffectsSelectionStep, } from '../shared-steps.js';
import { InteractionType } from '../../interactions/interactions.type.js';
import { PraiseReasonOptions } from '../reason-selection-constants.js';
export const praiseWizardFlow = {
    id: 'praise-questions-wizard',
    title: 'wizard:praiseQuestions.title',
    description: 'wizard:praiseQuestions.description',
    firstStepId: 'employee-selection',
    steps: [
        // Step 1: Employee Selection (6148711b345a7497e9f994a1)
        {
            id: 'employee-selection',
            title: 'wizard:questions.firstQuestion.title',
            component: {
                id: 'EmployeeSelection',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-employees',
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                    placeholder: {
                        type: 'static',
                        data: 'wizard:questions.firstQuestion.placeholder',
                    },
                },
            },
            nextStep: 'date-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.firstQuestion.validation';
                return null;
            },
        },
        // Step 2: Date Selection (6148711b5f516a34ad79089a)
        {
            id: 'date-selection',
            title: 'wizard:questions.dateSelection.title',
            component: {
                id: 'DateSelection',
                props: {
                    maxDate: {
                        type: 'static',
                        data: new Date(),
                    },
                },
            },
            nextStep: 'reason-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.dateSelection.validation';
                return null;
            },
        },
        // Step 3: Reason Selection (6148711b2514abf061df2399)
        {
            id: 'reason-selection',
            title: 'wizard:praiseQuestions.reasonSelection.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: PraiseReasonOptions.COLLABORATION_SERVICE,
                                title: 'wizard:praiseQuestions.reasonSelection.options.collaboration.title',
                            },
                            {
                                id: PraiseReasonOptions.SCHEDULE_AGREEMENT,
                                title: 'wizard:praiseQuestions.reasonSelection.options.scheduleAgreement.title',
                            },
                            {
                                id: PraiseReasonOptions.COMMUNICATION,
                                title: 'wizard:praiseQuestions.reasonSelection.options.communication.title',
                            },
                            {
                                id: PraiseReasonOptions.INFORMATION_SHARING,
                                title: 'wizard:praiseQuestions.reasonSelection.options.informationSharing.title',
                            },
                            {
                                id: PraiseReasonOptions.MEETING_EXPECTATIONS,
                                title: 'wizard:praiseQuestions.reasonSelection.options.meetingExpectations.title',
                            },
                            {
                                id: PraiseReasonOptions.PRAISE_FEEDBACK,
                                title: 'wizard:praiseQuestions.reasonSelection.options.praiseFeedback.title',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (currentAnswer) => {
                // Dynamic routing based on reason selection
                switch (currentAnswer[0]) {
                    case PraiseReasonOptions.MEETING_EXPECTATIONS:
                        return 'expectations-details';
                    case PraiseReasonOptions.PRAISE_FEEDBACK:
                        return 'praise-type-selection';
                    case PraiseReasonOptions.COLLABORATION_SERVICE:
                        return 'collaboration-service-type';
                    case PraiseReasonOptions.COMMUNICATION:
                        return 'communication-type-selection';
                    case PraiseReasonOptions.INFORMATION_SHARING:
                        return 'information-sharing-type';
                    case PraiseReasonOptions.SCHEDULE_AGREEMENT:
                        return 'schedule-agreement-type';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.reasonSelection.validation';
                return null;
            },
        },
        // Step 4a: Meeting Expectations Details (6148711b4bdaa256d0f44fc6)
        {
            id: 'expectations-details',
            title: 'wizard:praiseQuestions.expectationsDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.expectationsDetails.validation';
                return null;
            },
        },
        // Step 4b: Framework Selection for Expectations (6148711b2514abf061df23a2)
        createFrameworkSelectionStep('framework-selection', 'goal-selection', 'praise'),
        createBodyLanguageFrameworkSelectionStep('goal-selection'),
        createWrittenMessagesSelectionStep('goal-selection'),
        createVerbalExpressionsSelectionStep('goal-selection'),
        // Step 4c: Praise Type Selection (6148711c65a3305e8b101283)
        {
            id: 'praise-type-selection',
            title: 'wizard:praiseQuestions.praiseTypeSelection.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'praise-and-feedback',
                                title: 'wizard:praiseQuestions.praiseTypeSelection.options.praiseAndFeedback.title',
                            },
                            {
                                id: 'feedback-only',
                                title: 'wizard:praiseQuestions.praiseTypeSelection.options.feedbackOnly.title',
                            },
                            {
                                id: 'praise-only',
                                title: 'wizard:praiseQuestions.praiseTypeSelection.options.praiseOnly.title',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: 'praise-feedback-subject',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.praiseTypeSelection.validation';
                return null;
            },
        },
        // Step 4d: Collaboration/Service Type Selection (614871247b1e0319246feae0)
        {
            id: 'collaboration-service-type',
            title: 'wizard:praiseQuestions.collaborationServiceType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'service-response',
                                title: 'wizard:praiseQuestions.collaborationServiceType.options.serviceResponse.title',
                                description: 'wizard:praiseQuestions.collaborationServiceType.options.serviceResponse.description',
                            },
                            {
                                id: 'collaboration',
                                title: 'wizard:praiseQuestions.collaborationServiceType.options.collaboration.title',
                                description: 'wizard:praiseQuestions.collaborationServiceType.options.collaboration.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'service-response':
                        return 'service-description';
                    case 'collaboration':
                        return 'collaboration-description';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.collaborationServiceType.validation';
                return null;
            },
        },
        // Step 4e: Information Sharing Type (6148711e5f516a34ad790a3f)
        {
            id: 'information-sharing-type',
            title: 'wizard:praiseQuestions.informationSharingType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'general-info',
                                title: 'wizard:praiseQuestions.informationSharingType.options.generalInfo.title',
                                description: 'wizard:praiseQuestions.informationSharingType.options.generalInfo.description',
                            },
                            {
                                id: 'reporting',
                                title: 'wizard:praiseQuestions.informationSharingType.options.reporting.title',
                                description: 'wizard:praiseQuestions.informationSharingType.options.reporting.description',
                            },
                            {
                                id: 'decision-making',
                                title: 'wizard:praiseQuestions.informationSharingType.options.decisionMaking.title',
                                description: 'wizard:praiseQuestions.informationSharingType.options.decisionMaking.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 1,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'general-info':
                    case 'reporting':
                    case 'decision-making':
                        return 'information-sharing-details';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.informationSharingType.validation';
                return null;
            },
        },
        // Step 4f: Communication Type Selection (614871202514abf061df263a)
        {
            id: 'communication-type-selection',
            title: 'wizard:praiseQuestions.communicationType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'speech-tone',
                                title: 'wizard:praiseQuestions.communicationType.options.speechTone.title',
                                description: 'wizard:praiseQuestions.communicationType.options.speechTone.description',
                            },
                            {
                                id: 'general-conduct',
                                title: 'wizard:praiseQuestions.communicationType.options.generalConduct.title',
                                description: 'wizard:praiseQuestions.communicationType.options.generalConduct.description',
                            },
                            {
                                id: 'body-language',
                                title: 'wizard:praiseQuestions.communicationType.options.bodyLanguage.title',
                                description: 'wizard:praiseQuestions.communicationType.options.bodyLanguage.description',
                            },
                            {
                                id: 'written-messages',
                                title: 'wizard:praiseQuestions.communicationType.options.writtenMessages.title',
                                description: 'wizard:praiseQuestions.communicationType.options.writtenMessages.description',
                            },
                            {
                                id: 'verbal-expressions',
                                title: 'wizard:praiseQuestions.communicationType.options.verbalExpressions.title',
                                description: 'wizard:praiseQuestions.communicationType.options.verbalExpressions.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'speech-tone':
                        return 'speech-tone-details';
                    case 'general-conduct':
                        return 'general-conduct-details';
                    case 'body-language':
                        return 'body-language-details';
                    case 'written-messages':
                        return 'written-messages-details';
                    case 'verbal-expressions':
                        return 'verbal-expressions-details';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.communicationType.validation';
                return null;
            },
        },
        // Step 4g: Schedule Agreement Type (614871215f516a34ad790bd1)
        {
            id: 'schedule-agreement-type',
            title: 'wizard:praiseQuestions.scheduleAgreementType.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'procedure',
                                title: 'wizard:praiseQuestions.scheduleAgreementType.options.procedure.title',
                                description: 'wizard:praiseQuestions.scheduleAgreementType.options.procedure.description',
                            },
                            {
                                id: 'agreement-promise',
                                title: 'wizard:praiseQuestions.scheduleAgreementType.options.agreementPromise.title',
                                description: 'wizard:praiseQuestions.scheduleAgreementType.options.agreementPromise.description',
                            },
                            {
                                id: 'schedule',
                                title: 'wizard:praiseQuestions.scheduleAgreementType.options.schedule.title',
                                description: 'wizard:praiseQuestions.scheduleAgreementType.options.schedule.description',
                            },
                            {
                                id: 'goal-meeting',
                                title: 'wizard:praiseQuestions.scheduleAgreementType.options.goalMeeting.title',
                                description: 'wizard:praiseQuestions.scheduleAgreementType.options.goalMeeting.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => {
                switch (answer[0]) {
                    case 'procedure':
                    case 'agreement-promise':
                    case 'schedule':
                    case 'goal-meeting':
                        return 'schedule-agreement-details';
                    default:
                        return 'goal-selection';
                }
            },
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.scheduleAgreementType.validation';
                return null;
            },
        },
        // Additional detailed steps for specific flows
        // Schedule Agreement Details Step (Dynamic)
        {
            id: 'schedule-agreement-details',
            title: 'wizard:praiseQuestions.scheduleAgreementDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'goal-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.scheduleAgreementDetails.validation';
                return null;
            },
        },
        // Praise/Feedback Subject Steps
        {
            id: 'praise-feedback-subject',
            title: 'wizard:praiseQuestions.praiseFeedbackSubject.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'praise-feedback-recipient',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.praiseFeedbackSubject.validation';
                return null;
            },
        },
        {
            id: 'feedback-subject',
            title: 'wizard:praiseQuestions.feedbackSubject.title',
            description: 'wizard:praiseQuestions.feedbackSubject.description',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'feedback-recipient',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.feedbackSubject.validation';
                return null;
            },
        },
        {
            id: 'praise-subject',
            title: 'wizard:praiseQuestions.praiseSubject.title',
            description: 'wizard:praiseQuestions.praiseSubject.description',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'praise-recipient',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.praiseSubject.validation';
                return null;
            },
        },
        // Feedback Recipient Selection Step
        createRecipientSelectionStep('feedback-recipient', 'feedback-employee-selection', // next step if "employees" is selected
        'framework-selection', // next step if "me" is selected
        'wizard:praiseQuestions.praiseFeedbackRecipient.title'),
        // Feedback Employee Selection Step (when "employees" is chosen)
        createMultiSelectEmployeeSelectionStep('feedback-employee-selection', 'framework-selection'),
        // Praise Recipient Selection Step
        createRecipientSelectionStep('praise-recipient', 'praise-employee-selection', // next step if "employees" is selected
        'framework-selection', // next step if "me" is selected
        'wizard:praiseQuestions.praiseFeedbackRecipient.title'),
        // Praise Employee Selection Step (when "employees" is chosen)
        createMultiSelectEmployeeSelectionStep('praise-employee-selection', 'framework-selection'),
        // Service Description Step
        {
            id: 'service-description',
            title: 'wizard:praiseQuestions.serviceDescription.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.serviceDescription.validation';
                return null;
            },
        },
        // Collaboration Description Step
        {
            id: 'collaboration-description',
            title: 'wizard:praiseQuestions.collaborationDescription.title',
            description: 'wizard:praiseQuestions.collaborationDescription.description',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.collaborationDescription.validation';
                return null;
            },
        },
        // Information Sharing Details Step (Dynamic)
        {
            id: 'information-sharing-details',
            title: 'wizard:praiseQuestions.informationSharingDetails.title',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.informationSharingDetails.validation';
                return null;
            },
        },
        // Speech Tone Details Step
        {
            id: 'speech-tone-details',
            title: 'wizard:praiseQuestions.speechToneDetails.title',
            description: 'wizard:praiseQuestions.speechToneDetails.description',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'enthusiastic',
                                title: 'wizard:praiseQuestions.speechToneDetails.options.enthusiastic.title',
                                description: 'wizard:praiseQuestions.speechToneDetails.options.enthusiastic.description',
                            },
                            {
                                id: 'quick-fluent',
                                title: 'wizard:praiseQuestions.speechToneDetails.options.quickFluent.title',
                                description: 'wizard:praiseQuestions.speechToneDetails.options.quickFluent.description',
                            },
                            {
                                id: 'calm',
                                title: 'wizard:praiseQuestions.speechToneDetails.options.calm.title',
                                description: 'wizard:praiseQuestions.speechToneDetails.options.calm.description',
                            },
                            {
                                id: 'appropriate-laughter',
                                title: 'wizard:praiseQuestions.speechToneDetails.options.appropriateLaughter.title',
                                description: 'wizard:praiseQuestions.speechToneDetails.options.appropriateLaughter.description',
                            },
                            {
                                id: 'humor',
                                title: 'wizard:praiseQuestions.speechToneDetails.options.humor.title',
                                description: 'wizard:praiseQuestions.speechToneDetails.options.humor.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: 'verbal-expressions-framework-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.speechToneDetails.validation';
                return null;
            },
        },
        // General Conduct Details Step
        {
            id: 'general-conduct-details',
            title: 'wizard:praiseQuestions.generalConductDetails.title',
            description: 'wizard:praiseQuestions.generalConductDetails.description',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'checked-facts',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.checkedFacts.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.checkedFacts.description',
                            },
                            {
                                id: 'arrived-on-time',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.arrivedOnTime.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.arrivedOnTime.description',
                            },
                            {
                                id: 'involved-contributed',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.involvedContributed.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.involvedContributed.description',
                            },
                            {
                                id: 'acknowledged-viewpoint',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.acknowledgedViewpoint.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.acknowledgedViewpoint.description',
                            },
                            {
                                id: 'focused-conversation',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.focusedConversation.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.focusedConversation.description',
                            },
                            {
                                id: 'kept-topic',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.keptTopic.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.keptTopic.description',
                            },
                            {
                                id: 'kept-time',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.keptTime.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.keptTime.description',
                            },
                            {
                                id: 'no-interrupting',
                                title: 'wizard:praiseQuestions.generalConductDetails.options.noInterrupting.title',
                                description: 'wizard:praiseQuestions.generalConductDetails.options.noInterrupting.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: 'framework-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.generalConductDetails.validation';
                return null;
            },
        },
        // Body Language Details Step
        {
            id: 'body-language-details',
            title: 'wizard:praiseQuestions.bodyLanguageDetails.title',
            description: 'wizard:praiseQuestions.bodyLanguageDetails.description',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'hand-shake',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.handShake.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.handShake.description',
                            },
                            {
                                id: 'namaste',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.namaste.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.namaste.description',
                            },
                            {
                                id: 'hug',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.hug.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.hug.description',
                            },
                            {
                                id: 'thumbs-up',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.thumbsUp.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.thumbsUp.description',
                            },
                            {
                                id: 'hand-clap',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.handClap.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.handClap.description',
                            },
                            {
                                id: 'high-five',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.highFive.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.highFive.description',
                            },
                            {
                                id: 'smile',
                                title: 'wizard:praiseQuestions.bodyLanguageDetails.options.smile.title',
                                description: 'wizard:praiseQuestions.bodyLanguageDetails.options.smile.description',
                            },
                        ],
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: 'body-language-framework-selection',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.bodyLanguageDetails.validation';
                return null;
            },
        },
        // Written Messages Details Step
        {
            id: 'written-messages-details',
            title: 'wizard:praiseQuestions.writtenMessagesDetails.title',
            description: 'wizard:praiseQuestions.writtenMessagesDetails.description',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'written-communication-framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.writtenMessagesDetails.validation';
                return null;
            },
        },
        // Verbal Expressions Details Step
        {
            id: 'verbal-expressions-details',
            title: 'wizard:praiseQuestions.verbalExpressionsDetails.title',
            description: 'wizard:praiseQuestions.verbalExpressionsDetails.description',
            component: {
                id: 'TextArea',
                props: {
                    maxLength: {
                        type: 'static',
                        data: 500,
                    },
                    interactionType: {
                        type: 'static',
                        data: InteractionType.PRAISE,
                    },
                },
            },
            nextStep: 'verbal-expressions-framework-selection',
            validation: (answer) => {
                if (!answer || answer.trim().length === 0)
                    return 'wizard:praiseQuestions.verbalExpressionsDetails.validation';
                return null;
            },
        },
        // Praise/Feedback Recipient Step
        createRecipientSelectionStep('praise-feedback-recipient', 'praise-feedback-employee-selection', // next step if "employees" is selected
        'framework-selection', // next step if "me" is selected
        'wizard:praiseQuestions.praiseFeedbackRecipient.title'),
        // Praise/Feedback Employee Selection Step (when "employees" is chosen)
        createMultiSelectEmployeeSelectionStep('praise-feedback-employee-selection', 'framework-selection'),
        // Step 5: Goal Selection (6148711be35fe652264877a0)
        {
            id: 'goal-selection',
            title: 'wizard:praiseQuestions.goalSelection.title',
            component: {
                id: 'GoalsChoice',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-goals',
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: (answer) => answer === 'no-effect' ? 'additional-effects' : 'goal-impact-range',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.goalSelection.validation';
                return null;
            },
        },
        // Step 6: Goal Impact Range (6148711b7b1e0319246fe579)
        {
            id: 'goal-impact-range',
            title: 'wizard:praiseQuestions.goalImpactRange.title',
            component: {
                id: 'Range',
                props: {
                    min: {
                        type: 'static',
                        data: 1,
                    },
                    max: {
                        type: 'static',
                        data: 10,
                    },
                    minLabel: {
                        type: 'static',
                        data: 'wizard:praiseQuestions.goalImpactRange.minLabel',
                    },
                    maxLabel: {
                        type: 'static',
                        data: 'wizard:praiseQuestions.goalImpactRange.maxLabel',
                    },
                },
            },
            nextStep: 'additional-effects',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.goalImpactRange.validation';
                return null;
            },
        },
        // Step 7: Additional Effects (6148711b7b1e0319246fe581)
        createAdditionalEffectsSelectionStep('praise'),
        // Additional Effects Follow-up Step (Generic)
        {
            id: 'additional-effects-details',
            title: 'wizard:praiseQuestions.additionalEffectsDetails.title',
            component: {
                id: 'ChoiceList',
                props: {
                    options: {
                        type: 'static',
                        data: [
                            {
                                id: 'everyone',
                                title: 'wizard:praiseQuestions.relationOptions.everyone',
                            },
                            {
                                id: 'recipient',
                                title: 'wizard:praiseQuestions.relationOptions.recipient',
                            },
                            {
                                id: 'employees',
                                title: 'wizard:praiseQuestions.relationOptions.employees',
                            },
                            {
                                id: 'customers',
                                title: 'wizard:praiseQuestions.relationOptions.customers',
                            },
                            {
                                id: 'suppliers',
                                title: 'wizard:praiseQuestions.relationOptions.suppliers',
                            },
                            {
                                id: 'manager',
                                title: 'wizard:praiseQuestions.relationOptions.manager',
                            },
                            {
                                id: 'team',
                                title: 'wizard:praiseQuestions.relationOptions.team',
                            },
                            {
                                id: 'colleagues',
                                title: 'wizard:praiseQuestions.relationOptions.colleagues',
                            },
                            {
                                id: 'senior-management',
                                title: 'wizard:praiseQuestions.relationOptions.seniorManagement',
                            },
                        ],
                    },
                    columns: { type: 'static', data: 2 },
                },
            },
            nextStep: 'company-values',
            validation: (answer) => {
                if (!answer)
                    return 'wizard:praiseQuestions.additionalEffectsDetails.validation';
                return null;
            },
        },
        // Step 8: Company Values (6148711ce35fe652264877c8)
        {
            id: 'company-values',
            title: 'wizard:questions.companyValues.title',
            component: {
                id: 'CompanyValuesChoice',
                props: {
                    options: {
                        type: 'fetch',
                        data: 'fetch-company-values',
                    },
                    columns: {
                        type: 'static',
                        data: 2,
                    },
                },
            },
            nextStep: undefined, // This will complete the wizard
            validation: (answer) => {
                if (!answer)
                    return 'wizard:questions.companyValues.validation';
                return null;
            },
        },
    ],
};
